import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Label, mergeStyleSets } from '@fluentui/react';
export const getClassNames = (fill)=>{
    return mergeStyleSets({
        fillWidth: {
            width: `${fill}%`
        }
    });
};
export const RatingPercentages = ({ context, numberOfStars = 0, percentagesOfTotal = 0 })=>{
    const classNames = require('classnames');
    const { fillWidth } = getClassNames(percentagesOfTotal);
    const chartClasses = classNames('ratingsPercentagesChartFill', fillWidth);
    return /*#__PURE__*/ _jsxs("div", {
        className: "ratingPercentagesContainer",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "ratingPercentagesDetails",
                children: [
                    /*#__PURE__*/ _jsxs(Label, {
                        className: "ratingPercentagesNumOfStars",
                        children: [
                            numberOfStars,
                            " ",
                            context === null || context === void 0 ? void 0 : context.loc('Global_Loc_starsLower', 'stars')
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("text", {
                        className: "percentagesOfTotal",
                        children: [
                            "(",
                            percentagesOfTotal,
                            "%)"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "ratingsPercentagesChart",
                children: /*#__PURE__*/ _jsx("div", {
                    className: chartClasses
                })
            })
        ]
    });
};
